


  import {defineComponent} from 'vue';
  import ToTop from '@/components/shared/TopButtonComponent.vue';
  import Navigator from '@/components/shared/NavigatorComponent.vue';
  import SubNavigator from "@/components/shared/SubNavigator.vue";
  import NoTicketComponent from "@/components/ticketList/NoTicketComponent.vue";
  import TicketListItem from "@/components/ticketList/TicketListItem.vue";
  import PageableRequest from "@/domain/request/PageableRequest";
  import api from "@/api/backend-api";
  import Ticket from "@/domain/ticket/Ticket";
  import * as _ from "lodash";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters, mapMutations, mapState} from "vuex";
  import store from "@/store";

  export default defineComponent({
    name: 'MyUnusableTicket',
    components: {
      HeaderComponent,
      Navigator,
      SubNavigator,
      TicketListItem,
      NoTicketComponent,
      ToTop,
    },
    data() {
      return {
        page : 1 as number,
        perPage: 20 as number,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        isFirstLoading: true as boolean,

        debouncedScrollEvent: () => {return},

        tickets: [] as Array<Ticket>,
        totalCount: 0 as number
      }
    },
    computed: {
      isEmpty(): boolean {
        return this.totalCount === 0;
      },
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    mounted() {
      this.loadNewTicket();
      this.debouncedScrollEvent = _.debounce(this.infiniteScrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    methods: {
      statusClass(ticketStatus: string): string {
        switch(ticketStatus) {
            // 사용완료
          case "USED":
            return "is_complete";
            // 환불완료
          case "REFUNDED":
            return "is_refund";
            // 거절완료
          case "REJECT":
            return "is_refused";
            // 기한만료
          case "ISSUED":
          case "REFUNDING":
          case "REFUNDFAIL":
            return "is_passed";
          default:
            return "";
        }
      },
      infiniteScrollEvent(): void {
        const targetElement = document.getElementById("app");
        if (targetElement === undefined) {
          return;
        }

        const heightOfElement: number = targetElement!.scrollHeight;
        const topOfElement: number = window.scrollY;
        const clientHeightOfElement: number = targetElement!.clientHeight;
        const bottomOffset = 100;

        if (heightOfElement <= topOfElement + clientHeightOfElement + bottomOffset) {
          this.loadMoreTicket();
        }
      },
      loadNewTicket(): void {
        if (this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page = 1;
        this.hasMorePage = true;
        const request = new PageableRequest(this.page, this.perPage);

        api.getUnusableTicketList(request)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyUnusableTicketView'));
              router.push(new NamedRouting('NonMemberView', {channelId: store.state.ChannelStore.channelId}));
            }
            return;
          }

          this.totalCount = response.data.result.totalCount;
          this.tickets = response.data.result.ticketList.map(ticket => new Ticket(ticket));

          if (response.data.result.ticketList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isFirstLoading = false;
        });
      },
      loadMoreTicket(): void {
        if (!this.hasMorePage || this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page += 1;
        const request = new PageableRequest(this.page, this.perPage);

        api.getUnusableTicketList(request)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyUnusableTicketView'));
              router.push(new NamedRouting('NonMemberView', {channelId: store.state.ChannelStore.channelId}));
            }
            return;
          }

          response.data.result.ticketList.forEach(ticket => {
            this.tickets.push(new Ticket(ticket));
          });

          if (response.data.result.ticketList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      moveToDetailPage(ticketId: number): void {
        router.push(new NamedRouting('TicketDetailView', {'ticketId': ticketId}));
      },
    }
  })


